import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "main-nav" }
const _hoisted_2 = { class: "nav-container" }
const _hoisted_3 = { class: "nav-brand" }
const _hoisted_4 = ["alt"]
const _hoisted_5 = { class: "nav-links" }
const _hoisted_6 = ["href", "title", "target", "rel", "onClick", "innerHTML"]
const _hoisted_7 = {
  key: 2,
  class: "nav-dropdown"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "dropdown-menu" }
const _hoisted_10 = ["href", "title", "target", "rel", "innerHTML"]
const _hoisted_11 = {
  key: 1,
  class: "nav-links-stacked"
}
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  class: "dropdown-menu",
  style: {"display":"flex","position":"static","box-shadow":"none"}
}
const _hoisted_14 = ["href", "title", "target", "rel", "innerHTML"]
const _hoisted_15 = ["onClick", "innerHTML"]
const _hoisted_16 = ["href", "title", "target", "rel", "innerHTML"]
const _hoisted_17 = ["innerHTML"]

import { ref, computed } from 'vue';
import { useStore } from '../services/store.service';
import { useAuthService } from '../services/auth.service';
import { User } from '../types/api.types';

interface NavLink {
  label: string;
  to?: string;
  href?: string;
  class?: string;
  title?: string;
  target?: string;
  rel?: string;
  handleClick?: () => void;
  roles: string[]; // Allowed roles: 'admin', 'moderator', 'user', 'hideIfAuth', empty [] for public
  children?: NavLink[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppNavigation',
  setup(__props) {

const apiBaseUrl = process.env.VUE_APP_API_URL;
const store = useStore();
const logoAlt = store.readConfig<string>('SITE_NAME') || 'SITE_NAME';
const authService = useAuthService();

const isAuthenticated = computed(() => {
  return store.isAuthenticated() || false;
});

const user = computed(() => {
  const data = store.getData<User>('user');
  if (!isAuthenticated.value) {
    return { name: 'Profile', role: '' };
  }
  return data || { name: 'Profile', role: '' } as Pick<User, 'name' | 'role'>;
});

// Logout handler
const handleLogout = () => {
  authService.logout();
};

const navLinks = ref<NavLink[]>([
  {
    label: '<i class="bi bi-house"></i> Home',
    to: '/',
    title: `Home`,
    roles: [],
  },
  {
    label: '<i class="bi bi-gear"></i> Dashboard',
    roles: ['admin', 'moderator'],
    children: [
      {
        label: '<i class="bi bi-database-gear"></i> System',
        to: '/system',
        title: `System`,
        roles: ['admin'],
      },
      {
        label: '<i class="bi bi-people-fill"></i> Users',
        to: '/users',
        title: `Users`,
        roles: ['admin', 'moderator'],
      },
      {
        label: '<i class="bi bi-emoji-smile"></i> Bootstrap Icons',
        href: 'https://icons.getbootstrap.com/',
        title: 'Bootstrap Icons',
        target: '_blank',
        rel: 'noreferrer',
        roles: ['user', 'moderator', 'admin'],
      },
      {
        label: 'API error',
        href: apiBaseUrl,
        title: `API URL: ${apiBaseUrl}`,
        class: 'api-test',
        rel: 'noreferrer',
        roles: [],
      },
      {
        label: 'API Test',
        href: `${apiBaseUrl}/test`,
        class: 'api-test',
        title: `API URL: ${apiBaseUrl}`,
        target: '_blank',
        rel: "noreferrer",
        roles: ['admin'],
      },
    ]
  },
  {
    label: '<i class="bi bi-box-arrow-in-right"></i> Login',
    to: '/login',
    title: 'Login to the system',
    roles: ['hideIfAuth'],
  },
  {
    label: `<i class="bi bi-person-circle"></i> ${user.value.name}`,
    to: '/profile',
    title: user.value.name,
    roles: ['user', 'moderator', 'admin'],
  },
  {
    label: '<i class="bi bi-box-arrow-right"></i>',
    href: '#',
    title: 'Logout',
    handleClick: handleLogout,
    rel: 'noopener noreferrer',
    roles: ['user', 'moderator', 'admin'],
  },
]);

// Filter visible links based on authentication status
const filteredLinks = computed(() => {
  const userRole = user.value.role || '';
  
  function isAllowed(link: NavLink): boolean {
    if (link.roles.includes('hideIfAuth')) {
      return link.roles.includes('hideIfAuth') && !isAuthenticated.value;
    }
    if (link.roles.length === 0) {
      return true;
    }
    return link.roles.includes(userRole);
  }

  return navLinks.value
    .filter(isAllowed)
    .map(link => {
      if (link.children) {
        return {
          ...link,
          children: link.children.filter(isAllowed)
        };
      }
      return link;
    });
});

const isPortrait = computed(() => store.getOrientation() === 'portrait');

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "brand-link"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: "img/logo.svg",
              alt: _unref(logoAlt),
              class: "logo"
            }, null, 8, _hoisted_4)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        (!isPortrait.value)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(filteredLinks.value, (link, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                (link.to)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: link.to,
                      class: _normalizeClass(['nav-link', 'router-link', link.class, { 'router-link-active': _ctx.$route.path === link.to }]),
                      title: link.title || '',
                      target: link.target || '',
                      rel: link.rel || '',
                      innerHTML: link.label
                    }, null, 8, ["to", "class", "title", "target", "rel", "innerHTML"]))
                  : (link.href)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: link.href,
                        class: _normalizeClass(['nav-link', 'external-link', link.class]),
                        title: link.title,
                        target: link.target || '',
                        rel: link.rel || '',
                        onClick: ($event: any) => (link.handleClick ? link.handleClick() : null),
                        innerHTML: link.label
                      }, null, 10, _hoisted_6))
                    : _createCommentVNode("", true),
                (link.children)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("span", {
                        class: "nav-link dropdown-label",
                        innerHTML: link.label
                      }, null, 8, _hoisted_8),
                      _createElementVNode("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(link.children, (child, cidx) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: cidx }, [
                            (child.to)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  to: child.to,
                                  class: _normalizeClass(['nav-link', 'router-link', child.class, { 'router-link-active': _ctx.$route.path === child.to }]),
                                  title: child.title || '',
                                  target: child.target || '',
                                  rel: child.rel || '',
                                  innerHTML: child.label
                                }, null, 8, ["to", "class", "title", "target", "rel", "innerHTML"]))
                              : (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  href: child.href,
                                  class: _normalizeClass(['nav-link', child.class]),
                                  title: child.title,
                                  target: child.target || '',
                                  rel: child.rel || '',
                                  innerHTML: child.label
                                }, null, 10, _hoisted_10))
                          ], 64))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredLinks.value, (link, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  (link.children)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("span", {
                          class: "nav-link dropdown-label",
                          innerHTML: link.label
                        }, null, 8, _hoisted_12),
                        _createElementVNode("div", _hoisted_13, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(link.children, (child, cidx) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: cidx }, [
                              (child.to)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: child.to,
                                    class: "nav-link router-link",
                                    title: child.title || '',
                                    innerHTML: child.label
                                  }, null, 8, ["to", "title", "innerHTML"]))
                                : (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    href: child.href,
                                    class: "nav-link external-link",
                                    title: child.title,
                                    target: child.target || '',
                                    rel: child.rel || '',
                                    innerHTML: child.label
                                  }, null, 8, _hoisted_14))
                            ], 64))
                          }), 128))
                        ])
                      ], 64))
                    : (link.handleClick)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: "#",
                          class: "nav-link",
                          onClick: _withModifiers(($event: any) => (link.handleClick && link.handleClick()), ["prevent","stop"]),
                          innerHTML: link.label
                        }, null, 8, _hoisted_15))
                      : (link.to)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 2,
                            to: link.to,
                            class: "nav-link router-link",
                            title: link.title || '',
                            innerHTML: link.label
                          }, null, 8, ["to", "title", "innerHTML"]))
                        : (link.href)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 3,
                              href: link.href,
                              class: "nav-link external-link",
                              title: link.title,
                              target: link.target || '',
                              rel: link.rel || '',
                              innerHTML: link.label
                            }, null, 8, _hoisted_16))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 4,
                              class: "nav-link dropdown-label",
                              innerHTML: link.label
                            }, null, 8, _hoisted_17))
                ], 64))
              }), 128))
            ]))
      ])
    ])
  ]))
}
}

})